import { Feature } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { FEATURES_BASE_PATH } from '../constants/featuresBasePath';

export const getFeatures = async (
  constructGet: ConstructGet,
): Promise<NonPaginatedResponse<Feature[]> | undefined> =>
  constructGet<NonPaginatedResponse<Feature[]>>(FEATURES_BASE_PATH);
